const fakeShipmentData = {
  pickup_date: new Date().toISOString().split('T')[0],
  delivery_date: new Date(Date.now() + 86400000).toISOString().split('T')[0],
  pickup_postcode: '75001',
  delivery_postcode: '69001',
  number_of_pallets: 10,
  weight: '0T500',
  client_price: 1500.0,
  pickup_day_when: 'LE',
  pickup_time_when: 'A',
  pickup_hour: '8h',
  pickup_name: 'Entreprise Pickup',
  pickup_address1: '10 rue de Pickup',
  pickup_address2: 'Bat 1',
  pickup_city: 'Paris',
  pickup_reference: 'PU123456',
  pickup_contact: 'Jean Dupont',
  delivery_day_when: 'LE',
  delivery_time_when: 'APRES',
  delivery_hour: '19h',
  delivery_name: 'Entreprise Delivery',
  delivery_address1: '20 avenue de Delivery',
  delivery_address2: 'Bat B',
  delivery_city: 'Lyon',
  delivery_reference: 'DL654321',
  delivery_contact: 'Marie Curie',
  shipment_reference: 'SH123456',
  pallet_type: '120 x 120',
  pallet_height: 1.5,
  footage: 6,
  pallet_exchanger: false,
  number_of_exchangers: 0,
  semi_taut: true,
  porteur_taut: false,
  semi_fourgon: false,
  porteur_fourgon: false,
  semi_frigo: false,
  porteur_frigo: false,
  vingt_metres_cube: false,
  plateau: false,
  tail_lift: true,
  pallet_truck: true,
  adr: true,
  class_type: 2,
  un_code: 1134,
  grp: 'II',
  comments: 'Commentaire factice',
  carrier_due_date: new Date(Date.now() + 2592000000).toISOString().split('T')[0],
  internal_comments: 'Commentaire interne factice',
};

export default fakeShipmentData;
